var map = {
	"./assets/favicon.asset.png": "3de0",
	"./assets/fonts/avenir-lt-std/stylesheet.asset.css": "8504",
	"./assets/icons/icon-arrow-down.asset.svg": "53a2",
	"./assets/icons/icon-arrow-left-grey.asset.svg": "72a2",
	"./assets/icons/icon-arrow-left.asset.svg": "a4ba",
	"./assets/icons/icon-arrow-up.asset.svg": "a504",
	"./assets/icons/icon-down.asset.png": "e219",
	"./assets/icons/icon-flag-cn.asset.jpg": "f240",
	"./assets/icons/icon-flag-cn.asset.old.jpg": "1355",
	"./assets/icons/icon-flag-de.asset.jpg": "5deb",
	"./assets/icons/icon-flag-en-us.asset.jpg": "6c8f",
	"./assets/icons/icon-flag-es.asset.jpg": "ab4c",
	"./assets/icons/icon-flag-es.asset.old.jpg": "86bf",
	"./assets/icons/icon-flag-fr.asset.jpg": "aae2",
	"./assets/icons/icon-flag-pt.asset.jpg": "3c4c",
	"./assets/icons/icon-map.asset.svg": "4192",
	"./assets/icons/icon-play.asset.svg": "9118",
	"./assets/icons/icon-quote.asset.svg": "7e4d",
	"./assets/icons/icon-up-secondary.asset.png": "3859",
	"./assets/icons/icon-up.asset.png": "42f8",
	"./assets/icons/icon-up.asset.svg": "3e07",
	"./assets/images/challenges/recyclable-cover.asset.jpg": "dd4f",
	"./assets/images/challenges/recyclable-equipment.0.asset.jpg": "0fdc",
	"./assets/images/challenges/recyclable-packaging.0.asset.jpg": "e92d",
	"./assets/images/contact/contact-banner.asset.jpg": "ae3d",
	"./assets/images/contact/contact-banner.asset.png": "9d11",
	"./assets/images/equipments/equipments-expert-banner.asset.png": "e2ad",
	"./assets/images/equipments/equipments-expert-banner0.asset.jpg": "4c24",
	"./assets/images/equipments/equipments-specialties-banner.asset.png": "7662",
	"./assets/images/equipments/equipments-specialties-banner0.asset.jpg": "2b33",
	"./assets/images/equipments/equipments-standalone-banner.asset.png": "81df",
	"./assets/images/equipments/equipments-standalone-banner0.asset.png": "4af2",
	"./assets/images/homepage/homepage-agile-cover.asset.jpg": "84d8",
	"./assets/images/homepage/homepage-competitive-cover.asset.jpg": "c817",
	"./assets/images/homepage/homepage-interactive-cover.asset.jpg": "2f98",
	"./assets/images/homepage/homepage-recyclable-cover.asset.jpg": "cf34",
	"./assets/images/legals/legals-banner.asset.png": "c003",
	"./assets/logo.asset.png": "9916",
	"./assets/logo.asset.svg": "b9de",
	"./assets/placeholder-machine.asset.png": "e832",
	"./assets/placeholder-product.asset.png": "9764",
	"./assets/placeholder.asset.jpg": "1afd",
	"./assets/placeholder.asset.svg": "9719",
	"./assets/temp/innovation.0.asset.png": "75a2",
	"./assets/temp/innovation.1.asset.png": "d79f",
	"./assets/temp/temp-machine.asset.jpg": "7a7f",
	"./assets/temp/temp.asset.jpg": "f809",
	"./assets/temp/temp10.asset.jpg": "baa6",
	"./assets/temp/temp2.asset.jpg": "1405",
	"./plugins/light-gallery.runtime.ts": "659c",
	"./plugins/overlayscrollbars.runtime.ts": "7aa6",
	"./plugins/scroller.runtime.ts": "98d4",
	"./plugins/sticky.runtime.ts": "e2b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ff8";